// Bedtime-toast helpers.
//
// After 22:00 local time, on first landing of the night, we offer a soft
// nudge into Sleep Space. Rules:
//   • Window is 22:00 – 04:00 so people who open at 2am still get the offer.
//   • Fire once per "night" — a night keyed by the calendar date at 20:00.
//     Opening the app at 01:30 counts as the previous day's night, not a
//     fresh one, so a user who opens twice between midnight and morning
//     only sees the toast once.
//   • Never fire during daytime, ever.
//
// by David Hunt

const STORAGE_KEY = "stillwater.bedtimeToastNight";

// Return true between 22:00 and 04:00 local time.
export const isBedtimeWindow = (now = new Date()) => {
  const h = now.getHours();
  return h >= 22 || h < 4;
};

// The "night key" collapses 22:00 tonight and 01:30 tomorrow morning into
// the same key so we only nudge once per sleep opportunity.
export const getNightKey = (now = new Date()) => {
  const anchor = new Date(now);
  if (anchor.getHours() < 12) {
    // Early morning counts as the previous day's night.
    anchor.setDate(anchor.getDate() - 1);
  }
  const y = anchor.getFullYear();
  const m = String(anchor.getMonth() + 1).padStart(2, "0");
  const d = String(anchor.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

export const hasShownBedtimeToastTonight = (now = new Date()) => {
  try {
    return localStorage.getItem(STORAGE_KEY) === getNightKey(now);
  } catch (_) {
    return true; // fail closed — never spam if storage is broken
  }
};

export const markBedtimeToastShown = (now = new Date()) => {
  try {
    localStorage.setItem(STORAGE_KEY, getNightKey(now));
  } catch (_) {
    /* silent */
  }
};
